import { Suspense, type FC } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { NotFound } from "./pages/not_found";
import { useUser } from "./stores/user_store";
import { Loader } from "./components/loader";
import { Layout } from "./components/layout";
import { Logout } from "./pages/logout";
import { Dashboard } from "./pages/dashboard";
import { CertificatePolicies } from "./pages/certificate_policies";
import { DeviceGroups } from "./pages/device_groups";
import { Certificates } from "./pages/certificates";
import { Devices } from "./pages/devices";
import { Notifications } from "./pages/notifications";
import { Help } from "./pages/help";
import { Admin } from "./pages/admin";
import { AdminCustomerDetail } from "./pages/admin_customer_detail";
import { ModalManagerRenderer } from "./lib/modal_manager";

export const Router: FC = () => {
  const user = useUser();

  return (
    <BrowserRouter>
      <Layout user={user}>
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route
              path="/certificate-policies"
              element={<CertificatePolicies />}
            />
            <Route path="/device-groups" element={<DeviceGroups />} />
            <Route path="/certificates" element={<Certificates />} />
            <Route path="/devices" element={<Devices />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/admin" element={<Admin />} />
            <Route
              path="/admin/customers/:customerId"
              element={<AdminCustomerDetail />}
            />
            <Route path="/help" element={<Help />} />
            <Route path="/logout" element={<Logout />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
        <ModalManagerRenderer />
      </Layout>
    </BrowserRouter>
  );
};
